import { render, staticRenderFns } from "./iconNoQuestions.vue?vue&type=template&id=39736d62&scoped=true"
import script from "./iconNoQuestions.vue?vue&type=script&lang=js"
export * from "./iconNoQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39736d62",
  null
  
)

export default component.exports